<template>
  <div class="all" v-show="isReady">
    <h1 class="title">{{language.user_submitRecord}}</h1>
    <h2 style="margin: 50px; text-align:left;">
      {{language.user_title_hint}}
    </h2>
    <el-tabs v-model="activeName" class="main">
      <!-- <el-tab-pane label="全榜" name="first">
      </el-tab-pane> -->
      <el-card>
        <!-- <div slot="header">
        </div> -->
        <div class="main-content">
          <el-table
            :data="tableData" style="width: 100%"
            v-loading="deleteLoading"
            :header-row-style="{'color': '#ffffff','font-size':'17px'}"
            :header-cell-style="{background:'#64438D'}"
            :cell-style="function(){return 'font-weight: 700; color: black; '}"
            @row-click="handleRowClick"
          >
            <el-table-column type="expand">
          <template slot-scope="scope">
            <el-container>
              <el-main>
                <el-row>
                  <el-row>
                      <!-- <el-col
                        v-for="(i, index) in ads"
                        :key="index"
                        :span="Math.floor(24 / taskData.length)"
                        ><div class="">
                          <el-button type="text">{{ i.name }}</el-button>
                        </div></el-col
                      > -->
                      <el-col :span="6" v-if="showLines[0]&&scope.row.yyljcy!='—'">
                        <div class="">
                          <el-tooltip class="item" effect="dark" :content="language.leaderboard_yyljcy_hint" placement="top">
                            <el-button type="text" :style="scope.row.single_ability_bold[0]?'font-weight: bolder;':'font-weight: normal;'" @click="scope.row.single_ability_bold[0]=false;scope.row.single_ability_bold[1]=false;scope.row.single_ability_bold[2]=false;scope.row.single_ability_bold[3]=false;scope.row.single_ability_bold[4]=false;scope.row.single_ability_bold[5]=false;scope.row.single_ability_bold[6]=false;scope.row.single_ability_bold[0]=true;scope.row.show1=scope.row.yyljcy_dataset;scope.row.show2=isSelecting?scope.row.yyljcy_dataset[scope.row.yyljcy_first].dataset_score_list:scope.row.yyljcy_dataset">
                              <span :style="scope.row.single_ability_bold[0]?'padding-bottom: 2px; border-bottom: 1px solid #64438d;':''">
                                {{language.leaderboard_yyljcy}}
                              </span>
                            </el-button>
                          </el-tooltip>
                        </div>
                      </el-col>
                      <el-col :span="6" v-if="showLines[1]&&scope.row.yyljpj!='—'">
                        <div class="">
                          <el-tooltip class="item" effect="dark" :content="language.leaderboard_yyljpj_hint" placement="top">
                            <el-button type="text" :style="scope.row.single_ability_bold[1]?'font-weight: bolder;':'font-weight: normal;'" @click="scope.row.single_ability_bold[0]=false;scope.row.single_ability_bold[1]=false;scope.row.single_ability_bold[2]=false;scope.row.single_ability_bold[3]=false;scope.row.single_ability_bold[4]=false;scope.row.single_ability_bold[5]=false;scope.row.single_ability_bold[6]=false;scope.row.single_ability_bold[1]=true;scope.row.show1=scope.row.yyljpj_dataset;scope.row.show2=isSelecting?scope.row.yyljpj_dataset[scope.row.yyljpj_first].dataset_score_list:scope.row.yyljpj_dataset">
                              <span :style="scope.row.single_ability_bold[1]?'padding-bottom: 2px; border-bottom: 1px solid #64438d;':''">
                                {{language.leaderboard_yyljpj}}
                              </span>
                            </el-button>
                          </el-tooltip>
                        </div>
                      </el-col>
                      <el-col :span="6" v-if="showLines[2]&&scope.row.xxhq!='—'">
                        <div class="">
                          <el-tooltip class="item" effect="dark" :content="language.leaderboard_xxhq_hint" placement="top">
                            <el-button type="text" :style="scope.row.single_ability_bold[2]?'font-weight: bolder;':'font-weight: normal;'" @click="scope.row.single_ability_bold[0]=false;scope.row.single_ability_bold[1]=false;scope.row.single_ability_bold[2]=false;scope.row.single_ability_bold[3]=false;scope.row.single_ability_bold[4]=false;scope.row.single_ability_bold[5]=false;scope.row.single_ability_bold[6]=false;scope.row.single_ability_bold[2]=true;scope.row.show1=scope.row.xxhq_dataset;scope.row.show2=isSelecting?scope.row.xxhq_dataset[scope.row.xxhq_first].dataset_score_list:scope.row.xxhq_dataset">
                              <span :style="scope.row.single_ability_bold[2]?'padding-bottom: 2px; border-bottom: 1px solid #64438d;':''">
                                {{language.leaderboard_xxhq}}
                              </span>
                            </el-button>
                          </el-tooltip>
                        </div>
                      </el-col>
                      <el-col :span="6" v-if="showLines[3]&&scope.row.yysc!='—'">
                        <div class="">
                          <el-tooltip class="item" effect="dark" :content="language.leaderboard_yysc_hint" placement="top">
                            <el-button type="text" :style="scope.row.single_ability_bold[3]?'font-weight: bolder;':'font-weight: normal;'" @click="scope.row.single_ability_bold[0]=false;scope.row.single_ability_bold[1]=false;scope.row.single_ability_bold[2]=false;scope.row.single_ability_bold[3]=false;scope.row.single_ability_bold[4]=false;scope.row.single_ability_bold[5]=false;scope.row.single_ability_bold[6]=false;scope.row.single_ability_bold[3]=true;scope.row.show1=scope.row.yysc_dataset;scope.row.show2=isSelecting?scope.row.yysc_dataset[scope.row.yysc_first].dataset_score_list:scope.row.yysc_dataset">
                              <span :style="scope.row.single_ability_bold[3]?'padding-bottom: 2px; border-bottom: 1px solid #64438d;':''">
                                {{language.leaderboard_yysc}}
                              </span>
                            </el-button>
                          </el-tooltip>
                        </div>
                      </el-col>
                      <el-col :span="6" v-if="showLines[4]&&scope.row.dhjh!='—'">
                        <div class="">
                          <el-tooltip class="item" effect="dark" :content="language.leaderboard_dhjh_hint" placement="top">
                            <el-button type="text" :style="scope.row.single_ability_bold[4]?'font-weight: bolder;':'font-weight: normal;'" @click="scope.row.single_ability_bold[0]=false;scope.row.single_ability_bold[1]=false;scope.row.single_ability_bold[2]=false;scope.row.single_ability_bold[3]=false;scope.row.single_ability_bold[4]=false;scope.row.single_ability_bold[5]=false;scope.row.single_ability_bold[6]=false;scope.row.single_ability_bold[4]=true;scope.row.show1=scope.row.dhjh_dataset;scope.row.show2=isSelecting?scope.row.dhjh_dataset[scope.row.dhjh_first].dataset_score_list:scope.row.dhjh_dataset">
                              <span :style="scope.row.single_ability_bold[4]?'padding-bottom: 2px; border-bottom: 1px solid #64438d;':''">
                                {{language.leaderboard_dhjh}}
                              </span>
                            </el-button>
                          </el-tooltip>
                        </div>
                      </el-col>
                      <el-col :span="6" v-if="showLines[5]&&scope.row.dyy!='—'">
                        <div class="">
                          <el-tooltip class="item" effect="dark" :content="language.leaderboard_dyy_hint" placement="top">
                            <el-button type="text" :style="scope.row.single_ability_bold[5]?'font-weight: bolder;':'font-weight: normal;'" @click="scope.row.single_ability_bold[0]=false;scope.row.single_ability_bold[1]=false;scope.row.single_ability_bold[2]=false;scope.row.single_ability_bold[3]=false;scope.row.single_ability_bold[4]=false;scope.row.single_ability_bold[5]=false;scope.row.single_ability_bold[6]=false;scope.row.single_ability_bold[5]=true;scope.row.show1=scope.row.dyy_dataset;scope.row.show2=isSelecting?scope.row.dyy_dataset[scope.row.dyy_first].dataset_score_list:scope.row.dyy_dataset">
                              <span :style="scope.row.single_ability_bold[5]?'padding-bottom: 2px; border-bottom: 1px solid #64438d;':''">
                                {{language.leaderboard_dyy}}
                              </span>
                            </el-button>
                          </el-tooltip>
                        </div>
                      </el-col>
                      <el-col :span="6" v-if="showLines[6]&&scope.row.sxtl!='—'">
                        <div class="">
                          <el-tooltip class="item" effect="dark" :content="language.leaderboard_sxtl_hint" placement="top">
                            <el-button type="text" :style="scope.row.single_ability_bold[6]?'font-weight: bolder;':'font-weight: normal;'" @click="scope.row.single_ability_bold[0]=false;scope.row.single_ability_bold[1]=false;scope.row.single_ability_bold[2]=false;scope.row.single_ability_bold[3]=false;scope.row.single_ability_bold[4]=false;scope.row.single_ability_bold[5]=false;scope.row.single_ability_bold[6]=false;scope.row.single_ability_bold[6]=true;scope.row.show1=scope.row.sxtl_dataset;scope.row.show2=isSelecting?scope.row.sxtl_dataset[scope.row.sxtl_first].dataset_score_list:scope.row.sxtl_dataset">
                              <span :style="scope.row.single_ability_bold[6]?'padding-bottom: 2px; border-bottom: 1px solid #64438d;':''">
                                {{language.leaderboard_sxtl}}
                              </span>
                            </el-button>
                          </el-tooltip>
                        </div>
                      </el-col>
                    </el-row>
                  <hr class="inner-hr"/>
                  <el-row>
                    <el-row>
                      <el-col
                        v-for="(i, name, index) in scope.row.show1"
                        :key="index"
                        :span="Math.floor(24 / Object.keys(scope.row.show1).length)"
                      >
                        <div class="">
                          <el-button type="text" @click="isSelecting?scope.row.show2=i.dataset_score_list:isSelecting=isSelecting">
                            {{ isSelecting? name : i.task }}
                          </el-button>
                        </div>
                      </el-col>
                    </el-row>
                  </el-row>
                  <hr class="inner-hr"/>
                  <el-row>
                    <el-col
                      v-for="(i, index) in scope.row.show1"
                      :key="index"
                      :span="Math.floor(24 / scope.row.show1.length)"
                    >
                      <div class="">
                        <div class="score">
                          {{ i.score === null ? '' : i.score}}
                        </div>
                      </div>
                    </el-col>
                  </el-row>
                  <hr class="inner-hr"/>
                  <el-row>
                    <el-col
                      v-for="(i, index) in scope.row.show2"
                      :key="index"
                      :span="Math.floor(24 / scope.row.show2.length)"
                    >
                      <div class="">
                        <el-button type="text">
                          {{ i.name }}
                        </el-button>
                      </div>
                    </el-col>
                  </el-row>
                  <hr class="inner-hr"/>
                  <el-row>
                    <el-col
                      v-for="(i, index) in scope.row.show2"
                      :key="index"
                      :span="Math.floor(24 / scope.row.show2.length)"
                    >
                      <div class="">
                        <div class="score">
                          {{ i.score === null ? '' : i.score }}
                        </div>
                      </div>
                    </el-col>
                  </el-row>
                </el-row>
              </el-main>
            </el-container>
          </template>
        </el-table-column>
            <!-- <el-table-column :label="language.leaderboard_rank" prop="rank"> </el-table-column> -->
            <el-table-column :label="language.leaderboard_model" prop="name"> </el-table-column>
            <!-- <el-table-column label="机构" prop="org"> </el-table-column> -->
            <!-- <el-table-column label="论文链接" prop="plink">
              <template slot-scope="scope">
                <el-link :href="scope.row.plink">
                  <img src="https://z3.ax1x.com/2021/08/20/fOBmes.png" style="width:30px;height:30px;">
                </el-link>
              </template>
            </el-table-column>
            <el-table-column label="代码链接" prop="clink">
              <template slot-scope="scope">
                <el-link :href="scope.row.clink">
                  <img src="https://z3.ax1x.com/2021/08/20/fOBmes.png" style="width:30px;height:30px;">
                </el-link>
              </template>
            </el-table-column> -->
            <el-table-column :label="language.leaderboard_codepaper" prop="plink" min-width="130">
              <template slot-scope="scope">
                <el-link :href="scope.row.plink" :disabled="scope.row.plink==''">
                  <!-- <i class="el-icon-paperclip"></i> -->
                  <img :src="scope.row.plink==''?'https://z3.ax1x.com/2021/08/30/hYfZkV.png':'https://z3.ax1x.com/2021/08/20/fOBmes.png'" style="width:30px;height:30px;">
                </el-link>
                <el-link :href="scope.row.clink" :disabled="scope.row.clink==''">
                  <!-- <i class="el-icon-paperclip"></i> -->
                  <img :src="scope.row.clink==''?'https://z3.ax1x.com/2021/08/30/hYfZkV.png':'https://z3.ax1x.com/2021/08/20/fOBmes.png'" style="width:30px;height:30px;">
                </el-link>
              </template>
            </el-table-column>
            <!-- <el-table-column label="识记能力" prop="sj"> </el-table-column>
            <el-table-column label="理解能力" prop="lj"> </el-table-column>
            <el-table-column label="检索能力" prop="js"> </el-table-column>
            <el-table-column label="数值计算能力" prop="szjs"> </el-table-column>
            <el-table-column label="生成能力" prop="sc"> </el-table-column>
            <el-table-column label="多语言能力" prop="dyy"> </el-table-column>
            <el-table-column label="智源指数" prop="zy"> </el-table-column> -->
            <el-table-column :label="language.leaderboard_submittime" prop="stime" width="105">
              <template slot-scope="scope">
                {{scope.row.stime[0]}}
                <br>
                {{scope.row.stime[1]}}
              </template>
            </el-table-column>
            <el-table-column :label="language.leaderboard_yyljcy" prop="yyljcy" min-width="150" align="right"> </el-table-column>
            <el-table-column :label="language.leaderboard_yyljpj" prop="yyljpj" min-width="150" align="right"> </el-table-column>
            <el-table-column :label="language.leaderboard_xxhq" prop="xxhq" min-width="140" align="right"> </el-table-column>
            <el-table-column :label="language.leaderboard_yysc" prop="yysc" min-width="110" align="right"> </el-table-column>
            <el-table-column :label="language.leaderboard_dhjh" prop="dhjh" min-width="110" align="right"> </el-table-column>
            <el-table-column :label="language.leaderboard_dyy" prop="dyy" min-width="120" align="right"> </el-table-column>
            <el-table-column :label="language.leaderboard_sxtl" prop="sxtl" min-width="110" align="right"> </el-table-column>
            <!-- <el-table-column :label="language.leaderboard_zyzs" prop="score" min-width="120" align="center"> </el-table-column> -->
            <el-table-column :label="language.user_operation"  align="center">
              <template slot-scope="scope">
                <div v-show="scope.row.is_evaluate">
                  <el-button
                    size="mini"
                    type="danger"
                    @click="handleDelete(scope.$index, scope.row)">{{language.user_delete}}</el-button>
                  <el-button
                    size="mini"
                    type="primary"
                    @click="handleAdd(scope.$index, scope.row)">{{language.user_edit}}</el-button>
                  <el-button
                    size="mini"
                    type="primary"
                    :disabled="scope.row.public || scope.row.check === 1"
                    @click="handlePublic(scope.$index, scope.row)">{{scope.row.checkShow}}</el-button>
                    <!-- {{scope.row.check == 1 ? language.user_accepted : scope.row.check == -1 ? language.user_rejected : scope.row.public ? language.user_check : language.user_public}} -->
                </div>
                <div v-show="!scope.row.is_evaluate">
                  {{language.user_pending}}
                </div>
              </template>
            </el-table-column>
            <!-- <el-table-column label="总分" prop="score"> </el-table-column> -->
          </el-table>

          <el-dialog :visible.sync="visible" width="500px">
            <el-row class="input">
              <el-col :span="6">
                <el-select v-model="link.cpre" placeholder="">
                  <el-option label="http://" value="http://"></el-option>
                  <el-option label="https://" value="https://"></el-option>
                </el-select>
              </el-col>
              <el-col :span="18">
                <el-input
                  v-model="link.code"
                  :placeholder="language.user_code"
                  prefix-icon="el-icon-paperclip"
                  size="large"
                ></el-input>
              </el-col>
            </el-row>

            <el-row class="input">
              <el-col :span="6">
                <el-select v-model="link.ppre" placeholder="">
                  <el-option label="http://" value="http://"></el-option>
                  <el-option label="https://" value="https://"></el-option>
                </el-select>
              </el-col>
              <el-col :span="18">
                <el-input
                  v-model="link.paper"
                  :placeholder="language.user_paper"
                  prefix-icon="el-icon-paperclip"
                  size="large"
                ></el-input>
              </el-col>
            </el-row>
            <el-row class="input" style="vertical-align: bottom;">
              <el-button style="width: 100%" type="primary" @click="handleSubmit">
                {{language.user_submit}}
              </el-button>
            </el-row>
          </el-dialog>
        </div>
      </el-card>
    </el-tabs>

    <el-drawer
      :visible.sync="drawer"
      direction="rtl"
      size="30%"
      :with-header="false"
    >
      <div class="draw">
        <div class="draw-sub">
          <h1>{{language.leaderboard_model}}：{{drawerInfo.name}}</h1>
          <div class="draw-text">
            <!-- {{drawerInfo.link}} -->
            提交时间: {{drawerInfo.time}}
            <!-- <br>
            Score: {{drawerInfo.score}} -->
          </div>
          <div class="draw-text">
            参数数量: {{drawerInfo.paras}}
          </div>
        </div>
        <hr class="draw-hr">
        <!-- <div class="draw-sub">
          <h1>{{language.Model}}</h1>
          <div>
            {{drawerInfo.model}}
          </div>
        </div>
        <hr class="draw-hr"> -->
        <div class="draw-sub">
          <h1>提交参数</h1>
          <div class="draw-text">
            是否公开：{{drawerInfo.public ? language.yes : language.no}}
          </div>
          <div class="draw-text">
            是否使用预训练模型：{{drawerInfo.pre_train ? language.yes : language.no}}
          </div>
          <div class="draw-text">
            是否使用集成学习提升模型表现：{{drawerInfo.integrate ? language.yes : language.no}}
          </div>
          <div class="draw-text">
            是否使用多任务学习提升模型表现：{{drawerInfo.multiple ? language.yes : language.no}}
          </div>
          <!-- <div>
            {{drawerInfo.public}}
          </div> -->
        </div>
        <hr class="draw-hr">
        <div class="draw-sub">
          <h1>提交描述</h1>
          <!-- <div>
            提交描述
          </div> -->
          <div>
            {{drawerInfo.description}}
          </div>
          <hr class="draw-hr">
          <div>
            <el-link type="primary" :href="'/#/report?id='+drawerInfo.fileid">评测报告</el-link>
          </div>
        </div>

        <div class="draw-sub">
          <h1>{{language.user_public}}</h1>
          <div>
            申请状态： {{drawerInfo.checkShow}}
          </div>
          <!-- <div v-if="drawerInfo.public == 1&& check == None">
            申请状态： {{language.user_check}}
          </div>
          <div v-if="drawerInfo.check == 1">
            申请状态： {{language.user_accepted}}
          </div>
          <div v-if="drawerInfo.check == -1">
            申请状态： {{language.user_rejected}}
          </div> -->
          <div v-if="drawerInfo.check == -1">
            驳回原因： {{drawerInfo.message}}
          </div>
          <!-- 审核中： public == 1 && check == None
          审核通过：check == 1
          驳回： check == -1
          提交审核： public == 0 -->
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import config from '@/components/config.json'
export default {
  name: 'HelloWorld',
  data () {
    return {
      // ability_bold: [false, false, false, false, false, false, false],
      showLines: [true, true, true, true, true, true, true],
      isSelecting: false,
      isReady: false,
      deleteLoading: false,
      activeName: 'first',
      tableData: [],
      tb: {},
      drawerInfo: {
      },
      drawer: false,
      visible: false,
      link: {
        paper: '',
        code: '',
        ppre: 'http://',
        cpre: 'http://'
      }
    }
  },
  props: {
    language: Object,
    app: Object
  },
  mounted: function () {
    var that = this.$parent.$parent.$parent
    var tthis = this
    setTimeout(function () {
      // console.log('In User Mount:', this.app.isLogin)
      if (!that.isLogin) {
        tthis.$router.push({path: '/'})
      } else {
        tthis.handleInitData()

      // console.log('In User Mount:', that.isLogin)
      // if (!that.isLogin) {
      //   tthis.$alert(tthis.language.notlogin + ' ' + tthis.language.gologin, '', {
      //     confirmButtonText: 'OK'
      //     // cancelButtonText: tthis.language.Cancel
      //   }).then(() => {
      //     console.log('Submit Mount LOGIN')
      //     that.handleLoginStatus(true)
      //   }).catch(() => {
      //     tthis.$router.push({path: '/'})
      //     // this.$message({
      //     //   type: 'info',
      //     //   message: '已取消删除'
      //     // })
      //   })
      }
    }, 1 * 1000)
    // this.$alert(this.language.notlogin + ' ' + this.language.gologin, '', {
    //   confirmButtonText: 'OK'
    //   // cancelButtonText: tthis.language.Cancel
    // }).then(() => {
    //   this.$router.push({path: '/'})
    //   // console.log('Submit Mount LOGIN')
    //   // this.app.handleLoginStatus(true)
    // }).catch(() => {
    //   this.$router.push({path: '/'})
    //   // this.$message({
    //   //   type: 'info',
    //   //   message: '已取消删除'
    //   // })
    // })
  },
  methods: {
    handleAbilityBoldInit () {
      for (let i = 0; i < 7; i++) {
        this.ability_bold[i] = false
      }
    },
    handleInitData () {
      if (config.debug === 'true') {
        console.log('User Init', this.isReady)
      }
      this.isReady = true
      this.tableData = []
      this.$axios.post(config.API + config.getSubmitlist).then(res => {
        if (config.debug === 'true') {
          console.log(res)
        }
        if (res.status === 200) {
          // console.log(res)
          var t = res.data.record_list
          for (var i = 0; i < t.length; i++) {
            var r = t[i]
            var toAppend = {}
            var checkShow = ''
            if (r.check === 1) {
              checkShow = this.language.user_shtg
            } else if (r.check === -1) {
              checkShow = this.language.user_bh
            } else if (r.public && r.check === 0) {
              checkShow = this.language.user_shz
            } else if (!r.public) {
              checkShow = this.language.user_sqgk
            } else {
              checkShow = '　'
            }
            let aadss = true
            if (aadss) {
              toAppend = {
                checkShow: checkShow,
                rank: i + 1,
                name: r.模型名,
                org: 'Test',
                plink: r.论文链接,
                clink: r.代码链接,
                // sj_list: r.识记能力,
                // lj_list: r.理解能力,
                // js_list: r.检索能力,
                // szjs_list: r.数值计算能力,
                // sc_list: r.生成能力,
                // dyy_list: r.多语言能力,
                // sj: r.识记能力[0],
                // lj: r.理解能力[0],
                // js: r.检索能力[0],
                // szjs: r.数值计算能力[0],
                // sc: r.生成能力[0],
                // dyy: r.多语言能力[0],
                // zy_list: r.智源指数,
                // zy: r.智源指数[0],
                // sxtl: r.数学推理能力.ability_sum[0],
                // dyy: r.多语言能力.ability_sum[0],
                // dhjh: r.对话交互能力.ability_sum[0],
                // yysc: r.语言生成能力.ability_sum[0],
                // xxhq: r.信息获取及问答能力.ability_sum[0],
                // yyljpj: r['语言理解能力-篇章级'].ability_sum[0],
                // yyljcy: r['语言理解能力-词语级'].ability_sum[0],
                // score: r.智源指数[0],
                sxtl: r.数学推理能力 === -1 ? '—' : r.数学推理能力,
                dyy: r.多语言能力 === -1 ? '—' : r.多语言能力,
                dhjh: r.对话交互能力 === -1 ? '—' : r.对话交互能力,
                yysc: r.语言生成能力 === -1 ? '—' : r.语言生成能力,
                xxhq: r.信息获取及问答能力 === -1 ? '—' : r.信息获取及问答能力,
                yyljpj: r['语言理解能力-篇章级'] === -1 ? '—' : r['语言理解能力-篇章级'],
                yyljcy: r['语言理解能力-词句级'] === -1 ? '—' : r['语言理解能力-词句级'],
                paras: r.paras,
                sxtl_dataset: r.detail_score.数学推理能力.dataset_score_list,
                dyy_dataset: r.detail_score.多语言能力.dataset_score_list,
                dhjh_dataset: r.detail_score.对话交互能力.dataset_score_list,
                yysc_dataset: r.detail_score.语言生成能力.dataset_score_list,
                xxhq_dataset: r.detail_score.信息获取及问答能力.dataset_score_list,
                yyljpj_dataset: r.detail_score['语言理解能力-篇章级'].dataset_score_list,
                yyljcy_dataset: r.detail_score['语言理解能力-词句级'].dataset_score_list,
                show1: r.detail_score.多语言能力.dataset_score_list,
                show2: r.detail_score.多语言能力.dataset_score_list,
                // score: r.智源指数[0] + ' (' + r.智源指数[1] + ')',
                // score: r.智源指数[1],
                sxtl_sub: r.数学推理能力[1],
                dyy_sub: r.多语言能力[1],
                dhjh_sub: r.对话交互能力[1],
                yysc_sub: r.语言生成能力[1],
                xxhq_sub: r.信息获取及问答能力[1],
                yyljpj_sub: r['语言理解能力-篇章级'][1],
                yyljcy_sub: r['语言理解能力-词句级'][1],
                // score_sub: r.智源指数[1],
                sxtl_all: r.数学推理能力,
                dyy_all: r.多语言能力,
                dhjh_all: r.对话交互能力,
                yysc_all: r.语言生成能力,
                xxhq_all: r.信息获取及问答能力,
                yyljpj_all: r['语言理解能力-篇章级'],
                yyljcy_all: r['语言理解能力-词句级'],
                // score_all: r.智源指数,
                time: r.commit_time,
                description: r.description,
                public: r.public,
                multiple: r.multiple,
                integrate: r.integrate,
                pre_train: r.pre_train,
                fileid: r.fileid,
                stime: r.simple_commit_time.split(' '),
                check: r.check,
                message: r.message,
                is_evaluate: r.is_evaluate,
                single_ability_bold: [false, false, false, false, false, false, false]
              }
              if (toAppend.yyljcy !== '—') {
                toAppend.show1 = toAppend.yyljcy_dataset
                toAppend.show2 = toAppend.yyljcy_dataset
                toAppend.single_ability_bold[0] = true
              } else if (toAppend.yyljpj !== '—') {
                toAppend.show1 = toAppend.yyljpj_dataset
                toAppend.show2 = toAppend.yyljpj_dataset
                toAppend.single_ability_bold[1] = true
              } else if (toAppend.xxhq !== '—') {
                toAppend.show1 = toAppend.xxhq_dataset
                toAppend.show2 = toAppend.xxhq_dataset
                toAppend.single_ability_bold[2] = true
              } else if (toAppend.yysc !== '—') {
                toAppend.show1 = toAppend.yysc_dataset
                toAppend.show2 = toAppend.yysc_dataset
                toAppend.single_ability_bold[3] = true
              } else if (toAppend.dhjh !== '—') {
                toAppend.show1 = toAppend.dhjh_dataset
                toAppend.show2 = toAppend.dhjh_dataset
                toAppend.single_ability_bold[4] = true
              } else if (toAppend.dyy !== '—') {
                toAppend.show1 = toAppend.dyy_dataset
                toAppend.show2 = toAppend.dyy_dataset
                toAppend.single_ability_bold[5] = true
              } else if (toAppend.sxtl !== '—') {
                toAppend.show1 = toAppend.sxtl_dataset
                toAppend.show2 = toAppend.sxtl_dataset
                toAppend.single_ability_bold[6] = true
              }
            } else {
              toAppend = {
                rank: i + 1,
                name: r.模型名,
                org: 'Test',
                plink: r.论文链接,
                clink: r.代码链接
              }
            }
            this.tableData.push(toAppend)
            if (config.debug === 'true') {
              console.log(toAppend)
            }
          }
        }
      })
    },
    handleDelete (a, b) {
      let that = this
      this.deleteLoading = true
      if (config.debug === 'true') {
        console.log('delete', a, b.fileid)
      }
      let formData = new FormData()
      formData.append('fileid', b.fileid)
      this.$axios.post(config.API + config.toDelete, formData).then(res => {
        if (config.debug === 'true') {
          console.log(res)
        }
        if (res.status === 200) {
          // console.log(res)
          if (res.data.re_code === '0') {
            if (that.tableData.length === 1) {
              that.tableData = []
            } else {
              that.tableData.splice(a, 1)
            }
          }
        }
        that.deleteLoading = false
      })
    },
    handleAdd (a, b) {
      this.visible = true
      this.tb = b
      if (config.debug === 'true') {
        console.log('add', a, b, this.tb)
      }
    },
    handlePublic (a, b) {
      if (config.debug === 'true') {
        console.log('public', a, b.fileid, b)
      }
      let formData = new FormData()
      formData.append('fileid', b.fileid)
      this.$axios.post(config.API + config.toCheck, formData).then(res => {
        if (res.status === 200) {
          if (config.debug === 'true') {
            console.log('public', res)
          }
          location.reload()
        }
      })
    },
    handleSubmit (a, b) {
      this.visible = false
      let formData = new FormData()
      formData.append('paper_url', this.link.ppre + this.link.paper)
      formData.append('code_url', this.link.cpre + this.link.code)
      formData.append('fileid', this.tb.fileid)
      this.$axios.post(config.API + config.toEditLink, formData).then(res => {
        if (res.status === 200) {
          if (config.debug === 'true') {
            console.log('paper', res)
          }
          location.reload()
        }
      })
      // formData.append('type', 'code')
      // formData.append('url', this.link.code)
      // formData.append('fileid', this.tb.fileid)
      // this.$axios.post(config.API + config.toEditLink, formData).then(res => {
      //   if (res.status === 200) {
      //     console.log('code', res)
      //     // location.reload()
      //   }
      // })
    },
    handleRowClick (row, column, event) {
      if (config.debug === 'true') {
        console.log(column)
      }
      // this.drawerInfo.rank = row.rank
      // this.drawerInfo.name = row.name
      // this.drawerInfo.link = row.link
      // this.drawerInfo.date = row.date
      // this.drawerInfo.score = row.score
      // this.drawerInfo.model = row.model
      // this.drawerInfo.parameter = row.parameter
      // this.drawerInfo.more = row.more
      if (column.label !== this.language.user_operation && column.label !== this.language.leaderboard_codepaper) {
        this.drawerInfo = row
        this.drawer = true
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.all {
  width: 90%;
  margin: auto;
}
.title {
  text-align: left;
  margin: 50px;
  color: #64438d;
  font-size: 40px;
}
.main {
  margin: 50px;
}
.title-title {
  text-align: left;
  font-size: x-large;
  font-weight: bold;
}
.title-sub-section {
  text-align: left;
}
.title-sub-section-text {
  margin-right: 10px;
  display: inline;
  font-size: large;
  font-weight: bold;
}
.title-select {
  text-align: right;
}
.title-select-text {
  font-size: large;
  font-weight: bold;
}
.title-title,
.title-sub,
.title-select {
  margin-top: 20px;
}
.title-sub-section-btn{
  display: inline;
}
.inner-hr{
  height: 1px;
  background: #9AB1DE;
  border: 0;
}
.score{
  font-weight: bolder;
  color: black;
}

.draw{
  text-align: left;
  margin-left: 50px;
  margin-right: 50px;
}
.draw-sub{
  margin-top: 50px;
}
.draw-sub h1{
  color: #7857A1;
}
.draw-hr{
  margin-top: 50px;
}
.draw-text{
  margin-top: 20px;
}
.input{
  margin:30px;
}
.expand-up{
  color:#7857A1;
  font-weight: bold;
  text-align: center;
}
.expand-down{
  color:black;
  font-weight: bold;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/User.vue